import axios from 'axios';
import { push } from 'react-router-redux';
import { I18n } from 'react-redux-i18n';
import cookie from 'react-cookies';
import queryString from 'query-string';

// Utils.
import { getCookie, deleteLocalData } from 'utils';
import {
  clearJwtAccessTokenInBrowser,
  clearJwtSessionInBrowser,
} from 'utils/auth';

// Constants.
import * as AuthConstants from 'constants/AuthConstants';

function requestClearCookie() {
  return {
    type: AuthConstants.CLEAR_COOKIE_REQUEST,
  };
}

function receiveClearCookie() {
  return {
    type: AuthConstants.CLEAR_COOKIE_SUCCESS,
  };
}

export function clearCookie() {
  return (dispatch) => {
    dispatch(requestClearCookie());
    cookie.remove('web_user', { path: '/', domain: '.welltory.com' });
    cookie.remove('csrftoken', { path: '/', domain: '.welltory.com' });
    cookie.remove('csrftoken', { path: '/', domain: '.app.welltory.com' });
    cookie.remove('welltorysessionid', { path: '/', domain: '.welltory.com' });
    clearJwtAccessTokenInBrowser();
    delete axios.defaults.headers.post['X-CSRFToken'];
    delete axios.defaults.headers.put['X-CSRFToken'];
    delete axios.defaults.headers.patch['X-CSRFToken'];
    delete axios.defaults.headers.delete['X-CSRFToken'];
    delete axios.defaults.headers.common['Authorization'];
    dispatch(receiveClearCookie());
  };
}

export function clearLocalData() {
  deleteLocalData('chart-non-empty-key');
  deleteLocalData('chart-non-empty');
}

function requestLogin() {
  return {
    type: AuthConstants.LOGIN_REQUEST,
  };
}

function receiveLogin(userType) {
  return {
    type: AuthConstants.LOGIN_SUCCESS,
    userType,
  };
}

function receiveLoginError(message) {
  return {
    type: AuthConstants.LOGIN_FAILURE,
    message,
  };
}

export function loginDirect() {
  return (dispatch, getState) => {
    const { router: { location } } = getState();
    const query = queryString.parse(location.search);
    if (query && query.session_id && query.token) {
      dispatch(requestLogin());
      const csrftoken = query.token;
      const welltorysessionid = query.session_id;
      cookie.save('csrftoken', csrftoken, { domain: '.welltory.com', path: '/' });
      cookie.save('welltorysessionid', welltorysessionid, { domain: '.welltory.com', path: '/' });
      cookie.save('web_user', true, { domain: '.welltory.com', path: '/' });

      axios.defaults.headers.post['X-CSRFToken'] = csrftoken;
      axios.defaults.headers.put['X-CSRFToken'] = csrftoken;
      axios.defaults.headers.patch['X-CSRFToken'] = csrftoken;
      axios.defaults.headers.delete['X-CSRFToken'] = csrftoken;

      delete axios.defaults.headers.common['Authorization'];

      const userType = 'full-direct';
      dispatch(receiveLogin(userType));
    }
    else {
      const query = queryString.parse(location.search);
      let destination = query.destination || null;
      let pathname = `${window.location.origin}/auth/signin`;

      window.location.href = destination ? `${pathname}?destination=${destination}` : pathname;
    }
  };
}

export function loginToken(token) {
  return (dispatch, getState) => {
    dispatch(requestLogin());
    axios.defaults.headers.common['Authorization'] = `Token ${token}`;
    const userType = 'share';
    dispatch(receiveLogin(userType));
  }
}

export function logoutToken() {
  return (dispatch, getState) => {
    dispatch(requestLogout());
    delete axios.defaults.headers.common['Authorization'];
    const userType = 'not share';
    dispatch(receiveLogoutToken(userType));
    // dispatch(push({ pathname: url }));
  }
}

function requestLogout() {
  return {
    type: AuthConstants.LOGOUT_REQUEST,
  };
}

function receiveLogout() {
  return {
    type: AuthConstants.LOGOUT_SUCCESS,
  };
}

function receiveLogoutToken(userType) {
  return {
    type: AuthConstants.LOGOUT_TOKEN_SUCCESS,
    userType,
  };
}

export function goToLogin(useReferrer = true) {
  return () => {
    let destination = '';
    if (useReferrer) {
      const search = window.location.search;
      destination = window.location.pathname + search;
    }

    let pathname = `${window.location.origin}/auth/signin`;

    window.location.href = destination ? `${pathname}?destination=${destination}` : pathname;
  }
}

export function logout(isRedirect = true, pathname = '') {
  return (dispatch, getState) => {
    const { router: { location } } = getState();
    dispatch(requestLogout());

    const finishLogout = () => {
      dispatch(receiveLogout());
      clearLocalData();
      dispatch(clearCookie());

      if (isRedirect) {
        const query = queryString.parse(location.search);
        let destination = query.destination || null;

        if (pathname) {
          window.location.href = `${window.location.origin}${pathname}`;
          return;
        }

        let signInPath = `${window.location.origin}/auth/signin`;

        window.location.href = destination
          ? `${signInPath}?destination=${destination}`
          : signInPath;
      }
    };

    return clearJwtSessionInBrowser()
      .catch(() => {})
      .then(() =>
        axios({
          method: 'GET',
          url: '/dashboard_api/v1/user/logout/',
          skipJwtAuth: true,
        })
      )
      .then(() => finishLogout())
      .catch(() => finishLogout());
  };
}

export function clearMessage() {
  return (dispatch) => {
    const message = '';
    dispatch(receiveLoginError(message));
  };
}
